import { render, staticRenderFns } from "./complex.vue?vue&type=template&id=6bbacfc7&scoped=true"
import script from "./complex.vue?vue&type=script&lang=js"
export * from "./complex.vue?vue&type=script&lang=js"
import style0 from "./complex.vue?vue&type=style&index=0&id=6bbacfc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbacfc7",
  null
  
)

export default component.exports